import type { HeadingProps} from '@chakra-ui/react'
import { Heading, Tooltip } from '@chakra-ui/react'

import { useWizzardHeader } from '../../context/WizzardHeaderContext'

export interface WizzardHeaderTitleProps extends HeadingProps {
  text?: string
}

export const WizzardHeaderTitle = ({
  children,
  text,
  sx
}: WizzardHeaderTitleProps) => {
  const { isScrolled } = useWizzardHeader()

  return (
    <Tooltip label={text} hasArrow>
      <Heading
        sx={{
          color: 'white',
          fontSize: { base: 'md', lg: isScrolled ? 'lg' : '3xl' },
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          transition: 'all 200ms ease-in-out',
          whiteSpace: 'nowrap',
          ...sx
        }}
      >
        {children}
      </Heading>
    </Tooltip>
  )
}
